import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { EmotionalHook } from './components/EmotionalHook';
import { PainPoints } from './components/PainPoints';
import { ScienceSection } from './components/ScienceSection';
import { SocialProof } from './components/SocialProof';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { BonusSection } from './components/BonusSection';
import { TwoPaths } from './components/TwoPaths';
import { FinalCTA } from './components/FinalCTA';
import { StickyFooter } from './components/StickyFooter';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen bg-dark text-ivory font-body selection:bg-woodfire selection:text-white" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <main className="pt-10 sm:pt-12" data-id="element-2">
        {' '}
        {/* Offset for sticky announcement bar */}
        <HeroSection data-id="element-3" />
        <EmotionalHook data-id="element-4" />
        <PainPoints data-id="element-5" />
        <ScienceSection data-id="element-6" />
        <SocialProof data-id="element-7" />
        <ValueStack data-id="element-8" />
        <Guarantee data-id="element-9" />
        <BonusSection data-id="element-10" />
        <TwoPaths data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>
      <StickyFooter data-id="element-13" />
    </div>;
}